import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupB3 } from "../../../../../redux/app/orb3/groups/group-b";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupB3PreviewProps = OwnProps;

function ORB3GroupB3Preview(props: ORB3GroupB3PreviewProps) {
	const record = props.orb3Record as TORB3GroupB3;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemB3P1, itemB3P2 } = record;

	function renderItemEngineStart() {
		const { date: smtDate, time: smtTime } = itemB3P1.engineStart;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				{itemB3P1.recordEngine} started on {utcTime.format("HH:mm")} hrs UTC on{" "}
				{utcTime.format("DD-MMM-YYYY")} ({smtTime} SMT on{" "}
				{moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}) at{" "}
				{itemB3P1.startPosition.latitude} | {itemB3P1.startPosition.longitude}
			</h4>
		);
	}

	function renderItemEngineStop() {
		const { date: smtDate, time: smtTime } = itemB3P2.engineStop;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				{itemB3P2.recordEngine} stopped on {utcTime.format("HH:mm")} hrs UTC on{" "}
				{utcTime.format("DD-MMM-YYYY")} ({smtTime} SMT on{" "}
				{moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}) at{" "}
				{itemB3P2.stopPosition.latitude} | {itemB3P2.stopPosition.longitude}
			</h4>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-B", "B", renderItemEngineStart()],
					[null, null, "-", renderItemEngineStop()],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupB3Preview;
